import Logger from '@yandex-int/error-counter/dist/logger';

export const vzhikLogger = new Logger();
